<span [id]="id + 'ac53b30b-b97e-4842-ae92-f5e61b652374'" tabindex="0" (keydown)="onKeydown($event)">
  {{ linkName }}
  <a *ngIf="link" [id]="id + 'c0269a54-531a-4e86-af86-473b10474f05'" #linkElement [yatExternalLink]="link">
    <yat-icon id="6426fc38-8eee-4925-94e3-75ee17c31ca8" name="link-external-duo" [tooltipClass]="tooltipClass" [yatTooltip]="tooltipText"> </yat-icon>
  </a>
</span>
